import { Icon, SidebarMenuButton, SidebarMenuItem } from "@focal/ui-kit";
import { NavItem } from "@/components/common/AppSidebar/types";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { useNavItemClick } from "@/components/common/AppSidebar/components/useNavItemClick";

export const SidebarItem = ({
  title,
  icon,
  url,
  onClick,
  className,
  dataAttr,
  dataText,
}: NavItem & { className?: string; onClick?: () => void }) => {
  const pathname = usePathname();
  const active = url ? pathname?.includes(url) : false;

  const onButtonClick = useNavItemClick({ url, onClick, dataAttr, dataText });

  return (
    <SidebarMenuItem key={title} className={cn("group", className)}>
      <SidebarMenuButton
        tooltip={title}
        asChild
        isActive={active}
        className="mx-2 group-data-[collapsible=icon]:mx-0 cursor-pointer"
        onClick={onButtonClick}
      >
        <div className="flex group-data-[collapsible=icon]:justify-center">
          {icon ? (
            <Icon
              name={icon}
              size="md"
              className={cn(
                active ? "text-primary" : "text-typography-primary",
              )}
            />
          ) : (
            <></>
          )}
          <span
            className={cn(
              "text-sm font-medium group-data-[collapsible=icon]:hidden",
              active && "font-semibold",
            )}
          >
            {title}
          </span>
        </div>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
